'use client';

import { createContext, useEffect } from 'react';

import { useRouter } from 'next/navigation';

const ScrollContext = createContext();

const ScrollProvider = ({ children }) => {
  const router = useRouter();

  useEffect(() => {
    const handleHashChange = () => {
      const anchor = window.location.hash.substring(1);
      if (anchor) {
        const element = document.getElementById(anchor);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    if (window.location.hash) {
      handleHashChange();
    }

    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [router]);

  return <ScrollContext.Provider value={{}}>{children}</ScrollContext.Provider>;
};

export { ScrollProvider, ScrollContext };
